<template>
  <div id="user-eval-main" class="admin-container">
    <div class="container">
      <div class="small-box is-wider">
        <div class="page-title-and-information">
          <div class="custom">
            <h3>연세대학교 일반대학원 선발평가 시스템</h3>
          </div>
        </div>
        <div class="input-group without-label">
          <div class="notification is-warning is-light">
            <strong>{{ loggedInUserParts.memberName }}</strong> 님이 참여중인
            선발평가
          </div>
          <a
            style="float: right"
            @click="logout()"
            class="btn gradient-btn small"
            >로그아웃</a
          >
<!--          <a-->
<!--            v-if="isEvalGradMember"-->
<!--            style="float: right; margin-right: 10px; width: 120px; background-color: #569cf4"-->
<!--            @click="_openApplDoc()"-->
<!--            class="btn gradient-btn small"-->
<!--            >서류 열람 시스템</a-->
<!--          >-->
        </div>
        <div class="row">
          <div
            class="col col-12 admin-table-container">
            <table
              v-if="evalPeriodInfo.nowEvalPeriodCode === 'INTERVIEW'"
              v-bind:class="{ 'recommendation-table complete-bg' : evalPeriodInfo.isDone }"
              class="recommendation-table white-bg">
              <tbody>
              <tr>
                <th class="colored-th">참여 선발평가(구술심사)</th>
                <th class="colored-th">역할</th>
                <th class="colored-th">진행상태</th>
                <!--                  <th class="colored-th">서약서</th>-->
              </tr>
              <tr v-for="(item, index) in evalParams" :key="index"
                  @click="_click(item)"
              >
                <td
                v-if="item.evalType === 'INTERVIEW'"
                >
                  {{ item.evalPeriod }} {{ item.value }}
                </td>
                <td
                  v-if="isProfessor(item.evalRole) && item.evalType === 'INTERVIEW'"
                  >
                  주임교수
                </td>
                <td
                  v-else-if="isEvaluator(item.evalRole) && item.evalType === 'INTERVIEW'"
                  >
                  평가위원
                </td>
                <td
                  v-else-if="isAssistant(item.evalRole) && item.evalType === 'INTERVIEW'"
                >
                  실무위원
                </td>
                <td
                  v-if="item.evalType === 'INTERVIEW'"
                >{{ item.status.value }}</td>
                <!--                  <td v-if="item.vowFilePath !== null"><a @click="getDownUrl(item.vowFilePath, item.vowFilePath.slice(31, 68) )"-->
                <!--                  class="underline-btn">{{ item.vowFilePath.slice(31, 68) }}</a></td>-->
                <!--                  <td v-else>-</td>-->
              </tr>
              </tbody>
            </table>
            <table
              v-bind:class="{ 'recommendation-table complete-bg' : evalPeriodInfo.nowEvalPeriodCode === 'INTERVIEW' }"
              class="recommendation-table white-bg">
              <tbody>
              <tr>
                <th class="colored-th">참여 선발평가(서류심사)</th>
                <th class="colored-th">역할</th>
                <th class="colored-th">진행상태</th>
              </tr>
              <tr v-for="(item, index) in evalParams" :key="index"
                  @click="_click(item)"
              >
                <td
                  v-if="item.evalType === 'DOCUMENT'"
                >
                  {{ item.evalPeriod }} {{ item.value }}
                </td>
                <td
                  v-if="isProfessor(item.evalRole) && item.evalType === 'DOCUMENT'"
                >
                  주임교수
                </td>
                <td
                  v-else-if="isEvaluator(item.evalRole) && item.evalType === 'DOCUMENT'"
                >
                  평가위원
                </td>
                <td
                  v-else-if="isAssistant(item.evalRole) && item.evalType === 'DOCUMENT'"
                >
                  실무위원
                </td>
                <td
                v-if="item.evalType === 'DOCUMENT'"
                >{{ item.status.value }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import downloadMixin from '@/mixins/download'
import vowMixin from '@/mixins/vow'
import apxAlert from '@/wrapper/apex-alert'

export default {
  name: 'user-eval-type',
  props: {},
  mixins: [downloadMixin, vowMixin],
  data: () => ({
    isEvalGradMember: false,
    evalPeriodInfo: {
      oid: 0,
      year: 0,
      semester: 0,
      evaluationStartTime: '',
      evaluationEndTime: '',
      documentStartTime: '',
      documentEndTime: '',
      interviewStartTime: '',
      interviewEndTime: '',
      nowEvalPeriodCode: '',
      nowEvalPeriodValue: '',
      isStart: null,
      isDone: null
    }
  }),
  computed: {
    ...mapGetters({
      loggedInUserParts: 'users/loggedInUserParts',
      evalParams: 'users/evalParams',
      getEvalPeriodInfo: 'eval/getEvalPeriodInfo'
    })
  },
  watch: {},
  perimeters: [],
  components: {},
  methods: {
    ...mapActions({
      setNewToken: 'users/setNewToken',
      _getEvalPeriodInfo: 'eval/getEvalPeriodInfo',
      initializeEvalParams: 'users/initializeEvalParams'
    }),
    ...mapMutations({
      logout: 'users/LOGOUT',
      setRouteAuth: 'users/SET_ROUTER_AUTH',
      setSelectedEvalType: 'eval/SET_SELECTED_EVAL_TYPE'
    }),
    _openApplDoc () {
      window.open(document.location.protocol + '//' + document.location.host + '/appl/appl-list')
    },
    async _click (_data) {
      if (this.evalPeriodInfo.isStart === this.evalPeriodInfo.isDone
      ) {
        await apxAlert.success('연세대학교 선발심사 시스템', '평가 기간이 아닙니다.', '확인')
      } else {
        await this.setSelectedEvalType(_data.evalType)
        await this.setRouteAuth()
        await this.checkVow(_data)
      }
    }
  },
  async created () {
    await this.checkEvalGradRole(this.loggedInUserParts.userId).then(res => {
      this.isEvalGradMember = res
    })
    await this._getEvalPeriodInfo()
    this.evalPeriodInfo = this.getEvalPeriodInfo
    await this.initializeEvalParams()
  }
}
</script>
<style></style>
<style scoped></style>
